import * as React from "react"
import { formatCentsAsUsd } from "../../util/money"

interface Props {
  tripId: number
  bulkCreditName: string
  bulkCreditPaymentType: string
  isV2: boolean
  bulkCreditTotalFormatted: string
  bulkCreditAmount: number
  isDisabled: boolean
  disabledReason?: JSX.Element
  editBulkCreditTypePath: string
}

const lockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-lock"
    style={{ transform: "scale(0.75)", margin: "-4px 0px" }}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
)

const Header = (props: Props) => {
  const { tripId, bulkCreditName, bulkCreditTotalFormatted, isDisabled, disabledReason } = props
  return (
    <section className="section-setup bulk-credit-recipient-form--header">
      <div>
        {props.isV2 ? (
          <div className="grid sm:grid-cols-2">
            <h2 className="p-4">{bulkCreditName}</h2>
            <h2 className="p-4 sm:text-right">Amount: {bulkCreditTotalFormatted}</h2>
          </div>
        ) : (
          <h2 className="p-4">Credit Status</h2>
        )}

        <div className="grid gap-inline-10 border-t sm:grid-cols-3">
          <div className="stack gap-block-4 p-4 sm:col-span-2">
            <p className="">
              Apply credits according to your records. Once your credit is fully distributed the below button will change
              colors (from gray) and become active.
            </p>
            <div className="grid gap-4 items-center gap-inline-2 sm:grid-cols-3">
              <button className="cursor-pointer button" data-role="submit-button" type="submit" disabled={isDisabled}>
                {props.isV2 ? "Submit" : "Submit For Approval"}
              </button>

              <a className="button secondary whitespace-nowrap" href={props.editBulkCreditTypePath}>
                Edit Bulk Credit
              </a>

              <div className="sm:col-span-2">
                {isDisabled && disabledReason ? (
                  <div className="flex items-center" data-role="disabled-reason">
                    <span className="hidden sm:inline-block">{lockIcon}</span>
                    <span>{disabledReason}</span>
                  </div>
                ) : (
                  <div>All Set! Go ahead and submit</div>
                )}
              </div>
            </div>
          </div>
          {props.isV2 ? (
            <div className="p-4 mt-2 sm:mt-0">
              <span className="font-semibold">Next Step:</span> Payment type selection
            </div>
          ) : (
            <div className="p-4 mt-2 sm:mt-0">
              <span className="font-semibold">Next Step:</span> Once you've submitted your credit, the tour operator will
              review it and either reject it (with a note) or approve it. Their action will be notified to you via email.
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Header
